import Percentage from "../common/Percentage";

type Props = {
  activeSalons: number;
  percentage: number;
};

const ActiveSalons = ({ activeSalons, percentage }: Props) => {
  return (
    <div className="w-full h-fit bg-white px-6 py-4 rounded-lg flex items-center justify-between">
      <div className="flex flex-col justify-start gap-2">
        <span className="text-[#75757E] text-sm font-normal whitespace-nowrap">
          Active Salons
        </span>
        <span className="text-color-primary text-lg font-semibold text-start">
          {activeSalons}
        </span>
        <Percentage Percentage={percentage} />
      </div>
      <div className="bg-gradient-to-r from-color-primary to-[#28B2E1] w-[56px] h-[56px] rounded-full flex items-center justify-center">
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3014_35440)">
            <path
              d="M26.1666 6.54337L12.8549 19.8667L7.90825 14.92L9.55325 13.275L12.8549 16.5767L24.5216 4.91004L26.1666 6.54337ZM14.4999 23.8334C9.35492 23.8334 5.16659 19.645 5.16659 14.5C5.16659 9.35504 9.35492 5.16671 14.4999 5.16671C16.3316 5.16671 18.0466 5.70337 19.4933 6.62504L21.1849 4.93337C19.2833 3.61504 16.9849 2.83337 14.4999 2.83337C8.05992 2.83337 2.83325 8.06004 2.83325 14.5C2.83325 20.94 8.05992 26.1667 14.4999 26.1667C16.5183 26.1667 18.4199 25.6534 20.0766 24.7434L18.3266 22.9934C17.1599 23.53 15.8649 23.8334 14.4999 23.8334ZM22.6666 18H19.1666V20.3334H22.6666V23.8334H24.9999V20.3334H28.4999V18H24.9999V14.5H22.6666V18Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3014_35440">
              <rect
                width="28"
                height="28"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default ActiveSalons;
